import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {MechanicValidatorKnight} from '@colonist/game-mechanic-validators'
import {usePlayerValidators} from './usePlayerValidators'
import {useMapValidator} from './useMapValidator'

export const useKnightValidator = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const mechanicKnightState = useGameStore((state) => state.gameState.mechanicKnightState)
    if(mechanicKnightState == undefined) return undefined

    return useMemo(() => {
        const validator = new MechanicValidatorKnight(playerValidators, mapValidator, mechanicKnightState)
        return validator
    }, [playerValidators, mapValidator, mechanicKnightState])
}
